var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "70px",
    viewBox: "0 0 140 70",
    style: {
      enableBackground: "new 0 0 140 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 78.8174 43.8301)",
    style: {
      fill: "#623D8F",
      fontFamily: "'OpenSans-Bold'",
      fontSize: 25
    }
  }, "QES"), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M102.957,67.794c-18.083,0-32.794-14.71-32.794-32.792c0-18.084,14.711-32.796,32.794-32.796 c18.082,0,32.792,14.712,32.792,32.796C135.749,53.084,121.039,67.794,102.957,67.794z M102.957,3.481 c-17.379,0-31.519,14.14-31.519,31.521c0,17.378,14.14,31.517,31.519,31.517c17.378,0,31.517-14.139,31.517-31.517 C134.474,17.622,120.335,3.481,102.957,3.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#9C9B9B",
      strokeWidth: 1.2756,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M52.675,12.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M47.742,39.111c-0.001,0-0.002,0-0.003,0l-10.29-0.051c-0.353-0.002-0.637-0.289-0.635-0.641 s0.287-0.635,0.638-0.635c0.001,0,0.002,0,0.003,0l10.29,0.051c0.353,0.002,0.637,0.289,0.635,0.641S48.093,39.111,47.742,39.111z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M52.525,41.542c-0.001,0-0.003,0-0.004,0l-4.799-0.031c-0.169-0.001-0.331-0.069-0.45-0.189 c-0.118-0.12-0.185-0.283-0.184-0.452l0.031-4.797c0.002-0.351,0.287-0.634,0.638-0.634c0.001,0,0.003,0,0.004,0l4.797,0.031 c0.353,0.002,0.636,0.29,0.634,0.642l-0.029,4.797c-0.001,0.169-0.069,0.331-0.189,0.45 C52.854,41.476,52.693,41.542,52.525,41.542z M48.368,40.239l3.523,0.023l0.021-3.521l-3.521-0.023L48.368,40.239z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M59.091,22.125c-0.001,0-0.003,0-0.004,0l-4.798-0.03c-0.169-0.001-0.331-0.069-0.45-0.189 c-0.118-0.121-0.185-0.283-0.184-0.452l0.031-4.798c0.002-0.351,0.287-0.634,0.638-0.634c0.001,0,0.003,0,0.004,0l4.799,0.031 c0.169,0.001,0.331,0.069,0.45,0.19c0.119,0.12,0.185,0.283,0.184,0.452l-0.032,4.797C59.727,21.842,59.441,22.125,59.091,22.125z  M54.935,20.823l3.522,0.022l0.024-3.521l-3.523-0.023L54.935,20.823z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M48.844,55.958c-0.183,0-0.366-0.07-0.505-0.211l-3.369-3.416c-0.132-0.134-0.205-0.315-0.204-0.503 c0.002-0.188,0.077-0.368,0.211-0.5l3.414-3.367c0.279-0.274,0.727-0.273,1.002,0.007l3.373,3.413 c0.133,0.134,0.206,0.314,0.205,0.503c-0.002,0.188-0.077,0.367-0.212,0.5l-3.418,3.37C49.203,55.89,49.023,55.958,48.844,55.958z  M46.477,51.84l2.374,2.407l2.408-2.375l-2.377-2.404L46.477,51.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M69.939,36.632c-0.001,0-0.002,0-0.003,0l-8.75-0.042c-0.2-0.001-0.39-0.086-0.523-0.234 l-6.562-7.287l-13.023-0.062c-0.392-0.001-0.708-0.32-0.706-0.712c0.002-0.39,0.319-0.705,0.709-0.705c0.001,0,0.002,0,0.003,0 l13.337,0.063c0.2,0.001,0.39,0.086,0.523,0.234l6.562,7.287l8.437,0.041c0.392,0.002,0.708,0.32,0.706,0.712 C70.646,36.316,70.329,36.632,69.939,36.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M38.304,31.59c-0.002,0-0.021,0-0.023,0c-0.884-0.005-1.713-0.355-2.334-0.985 c-0.621-0.629-0.96-1.463-0.954-2.348c0.01-1.815,1.496-3.293,3.312-3.293c1.851,0.014,3.327,1.511,3.315,3.338 C41.606,30.116,40.119,31.59,38.304,31.59z M38.315,26.381c-1.05,0-1.9,0.846-1.905,1.885c-0.004,0.507,0.189,0.984,0.545,1.344 c0.354,0.36,0.829,0.56,1.334,0.563l0.015,0.708v-0.708c1.039,0,1.891-0.844,1.897-1.88C40.209,27.247,39.362,26.389,38.315,26.381 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M46.536,12.316c-0.002,0-0.021,0-0.022,0c-0.865-0.005-1.677-0.348-2.285-0.963 c-0.607-0.616-0.938-1.432-0.933-2.298c0.01-1.777,1.463-3.223,3.24-3.223c1.811,0.013,3.257,1.479,3.244,3.267 C49.769,10.873,48.312,12.316,46.536,12.316z M46.548,7.107c-1.089,0-1.971,0.877-1.977,1.956 c-0.004,0.526,0.197,1.021,0.565,1.394s0.86,0.581,1.385,0.584l0.015,0.638v-0.638c1.078,0,1.961-0.875,1.969-1.951 C48.512,8.005,47.635,7.116,46.548,7.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M47.034,51.004c-0.184,0-0.367-0.071-0.506-0.213l-3.387-3.457H9.007 c-2.123-0.015-4.842-2.217-4.827-4.536l0.147-19.839c0.015-2.131,2.552-5.143,4.908-5.143c0.006,0,0.012,0,0.018,0h22.626 c0.392,0,0.709,0.317,0.709,0.708s-0.317,0.708-0.709,0.708H9.248c-1.377-0.037-3.492,2.226-3.503,3.736L5.598,42.808 c-0.009,1.384,1.874,3.099,3.414,3.108h34.428c0.19,0,0.373,0.077,0.506,0.213l3.595,3.67c0.274,0.28,0.27,0.729-0.01,1.002 C47.393,50.937,47.213,51.004,47.034,51.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M53.92,19c-0.001,0-0.002,0-0.002,0l-16.062,0.077c-0.353-0.001-0.637-0.188-0.636-0.541 C37.221,18.185,37.506,18,37.857,18c0.001,0,0.002,0,0.002,0l16.062,0.027c0.353,0.001,0.637,0.136,0.636,0.489 C54.557,18.867,54.271,19,53.92,19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#623D8F",
      strokeWidth: 1.4173,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M31.938,46.296"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M21.746,35.395c-2.777,0-5.038-2.263-5.038-5.044v-2.72c0-2.783,2.261-5.047,5.038-5.047 c2.779,0,5.041,2.264,5.041,5.047v2.72C26.787,33.132,24.525,35.395,21.746,35.395z M21.746,24c-1.996,0-3.62,1.629-3.62,3.63 v2.72c0,2,1.624,3.627,3.62,3.627c1.998,0,3.623-1.627,3.623-3.627v-2.72C25.369,25.629,23.744,24,21.746,24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#623D8F"
    },
    d: "M30.417,46.487c-0.392,0-0.709-0.317-0.709-0.709v-2.879c0-2.211-1.277-4.012-3.289-4.689 c-1.034,0.957-2.676,1.579-4.245,1.579h-0.853c-1.569,0-3.212-0.622-4.246-1.579c-2.011,0.678-3.288,2.479-3.288,4.689v2.879 c0,0.392-0.317,0.709-0.709,0.709s-0.709-0.317-0.709-0.709v-2.879c0-3.019,1.861-5.443,4.741-6.177 c0.256-0.066,0.535,0.02,0.712,0.224c0.723,0.839,2.161,1.425,3.499,1.425h0.853c1.337,0,2.775-0.586,3.498-1.425 c0.176-0.204,0.453-0.29,0.712-0.224c2.836,0.723,4.742,3.205,4.742,6.177v2.879C31.126,46.17,30.809,46.487,30.417,46.487z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9B9B"
    },
    d: "M46.537,19.162c-0.353,0-0.638-0.286-0.638-0.638v-6.616c0-0.352,0.285-0.638,0.638-0.638 s0.638,0.286,0.638,0.638v6.616C47.175,18.876,46.89,19.162,46.537,19.162z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQes);
export default __webpack_public_path__ + "static/media/QES.4f752e2dece42ee7f76a928e4e6a0914.svg";
export { ForwardRef as ReactComponent };